import { render, staticRenderFns } from "./write.vue?vue&type=template&id=4797a0d2"
import script from "./write.vue?vue&type=script&lang=js"
export * from "./write.vue?vue&type=script&lang=js"
import style0 from "./write.vue?vue&type=style&index=0&id=4797a0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports